import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineFileProtect } from "react-icons/ai";
import { FaLink } from "react-icons/fa";
import { MdPolicy } from "react-icons/md";
import { FaFacebookSquare } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { BsInstagram } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { IoMail } from "react-icons/io5";
import { BiSolidPhoneCall } from "react-icons/bi";
import { FcLike } from "react-icons/fc";
import { FaGoogle } from "react-icons/fa";
import FastImage from "../FastImage";
import { IoLocationSharp } from "react-icons/io5";
import gbusiness from "../assets/google-mybusiness.png";

import { auto } from "@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core";

const Footer = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  return (
    <>
      <footer className="footer-main">
        <div className="container">
          <div className="row footer-row-upper">
            <div className="col-sm-12 com-md-3 col-lg-3">
              <div className="footer-logo">
                <FastImage
                  url={"Website%20Img/beemaone.jpg?updatedAt=1718789827025"}
                  width={auto}
                  height={auto}
                  alt={"logo"}
                  src={"Website%20Img/beemaone.jpg?updatedAt=1718789827025"}
                />
              </div>
              <p className="footer-about-text">
                Our friendly customer support team is your extended family.
                Speak your heart out. They listen with undivided attention to
                resolve your concerns. Give us a call, request a callback or
                drop us an email, we’re here to help.
              </p>
              <div
                className="footer-address"
                style={{
                  display: "flex",

                  marginTop: "5px",
                }}
              >
                <IoLocationSharp
                  style={{
                    marginRight: "6px",
                    fontSize: "50px",
                    marginTop: "-8px",
                  }}
                ></IoLocationSharp>
                <p className="footer-about-text">
                  2nd Floor, 47, Shyama Prasad Mukherjee Road, Hazra More,
                  Kolkata, West Bengal 700026
                </p>
              </div>
              <div className="contact-info">
                <Link to="mailto:communication@beema1.com">
                  <IoMail style={{ marginRight: "5px" }} />{" "}
                  communication@beema1.com
                </Link>
                <Link to="tel:+919051911171">
                  {" "}
                  <IoCall style={{ marginRight: "5px" }} />
                  +919051911171
                </Link>
              </div>
              <div className="social-contact">
                <Link
                  to="https://www.facebook.com/beemaone/?_rdr"
                  className="sociallink"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookSquare style={{ fontSize: "18pt" }} />
                </Link>
                <Link
                  to="https://in.linkedin.com/company/beema1"
                  className="sociallink"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin style={{ fontSize: "18pt" }} />
                </Link>
                {/* <Link to ="javascript:void(0)" className='sociallink'><FaSquareXTwitter style={{fontSize:'18pt'}}/></Link> */}
                <Link
                  to="https://www.instagram.com/beemaone/"
                  className="sociallink"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BsInstagram style={{ fontSize: "18pt" }} />
                </Link>

                <Link
                  to="https://g.page/r/CdRCuiqSNoK_EBM/"
                  className="sociallink social-with-label"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={gbusiness}
                    alt="Google Business Profile"
                    className="social-custom-icon"
                    style={{ fontSize: "18pt", height: "26px" }}
                  />
                </Link>

                <Link
                  to="https://x.com/Beemaone"
                  className="sociallink social-with-label"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaSquareXTwitter style={{ fontSize: "18pt" }} />
                </Link>
                {/* <Link to ="javascript:void(0)" className='sociallink'><IoLogoYoutube style={{fontSize:'18pt'}}/></Link> */}
              </div>
            </div>
            <div className="col-sm-12 com-md-3 col-lg-3">
              <div className="footer-link">
                <h6>
                  <AiOutlineFileProtect />
                  Insurance
                </h6>
                <ul>
                  <li>
                    <Link to="/car-insurence">Car Insurance</Link>
                  </li>
                  <li>
                    <Link to="/bike-insurance">Bike Insurance</Link>
                  </li>
                  <li>
                    <Link to="/health-insurance">Health Insurance</Link>
                  </li>
                  <li>
                    <Link to="/term-insurance">Term Insurance</Link>
                  </li>
                  {/* <li><Link to ="/travel-insurence">Travel Insurance</Link></li> */}
                </ul>
              </div>
            </div>
            <div className="col-sm-12 com-md-3 col-lg-3">
              <div className="footer-link">
                <h6>
                  <FaLink style={{ marginRight: "5px" }} />
                  Quick Links
                </h6>
                <ul>
                  <li>
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li>
                    <Link to={"/about-us"}>About us</Link>
                  </li>
                  <li>
                    <Link to={"/contactUs"}>Contact us</Link>
                  </li>
                  <li>
                    <Link to={"/blogs"}>Blogs</Link>
                  </li>
                  <li>
                    <Link to={"/career"}>Careers</Link>
                  </li>
                  <li>
                    <Link to={"/calculator"}>Calculators</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-12 com-md-3 col-lg-3">
              <div className="footer-link">
                <h6>
                  <MdPolicy style={{ marginRight: "5px" }} />
                  Other Links
                </h6>
                <ul>
                  <li>
                    <Link to={"/termsandcondition"}>Terms and Conditions</Link>
                  </li>
                  <li>
                    <Link to={"/privacy-policy"}>Privacy Policy</Link>
                  </li>
                </ul>
              </div>
              <Link className="toll-free-number" to="tel:+913323593438">
                <div className="left-icon">
                  <BiSolidPhoneCall
                    style={{ fontSize: "25pt", color: "#263734" }}
                  />
                </div>
                <div className="tollfree-text">
                  <p>Contact Us</p>
                  <p>+913323593438</p>
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className="bottomlicence">
          <div className="row footer-row-below container">
            <div className="col-sm-12 col-md-8 col-lg-8">
              <p className="down-footer-text bold">
                Disclaimer and Regulatory Information: Standard terms and
                conditions apply. Any discounts, savings, or insurance proposals
                displayed on this platform are offered directly by the
                respective insurance companies and are subject to approval by
                the Insurance Regulatory and Development Authority of India
                (IRDAI) in accordance with applicable product regulations and
                “file and use” guidelines. Savings related to motor insurance
                are based on quotations derived under the prevailing Indian
                Motor Tariff norms. For a complete understanding of coverage,
                exclusions, risk factors, and applicable terms, customers are
                advised to carefully review the official sales brochure and
                policy documents issued by the concerned insurer before making a
                purchase decision. Tax benefits, if any, are governed by
                prevailing tax laws and may be revised from time to time as per
                statutory amendments. beema1.com is an online insurance
                comparison and facilitation platform operated by Guide2Protect
                Insurance Web Aggregator Private Limited, an IRDAI-licensed
                insurance web aggregator, with its certificate of registration
                number 042 and registration code IRDAI/INT/WBA/79/2025. By
                sharing your contact details on this platform, you consent to
                Guide2Protect Insurance Web Aggregator Private Limited (Beema1)
                contacting you in the future through calls, SMS, emails,
                WhatsApp, or other communication channels for service-related or
                informational purposes.
              </p>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4">
              <div className="bima-class-one">
                <FastImage
                  url={"Website%20Img/irdia.png?updatedAt=1718786083442"}
                  width={auto}
                  height={auto}
                  alt={"irda"}
                  src={"Website%20Img/irdia.png?updatedAt=1718786083442"}
                />
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="container-fluid">
        <div className="row last-footer-new">
          <div className="col-sm-12 col-md-12 col-lg-12 flexxx">
            <span className="bottomtext">
              &#169; Made With{" "}
              <FcLike style={{ fontSize: "20pt", paddingBottom: "5px" }} /> By{" "}
              <span className="beema">beema</span>{" "}
              <span className="beema1">1</span> Copyright {currentYear} All
              Rights Reserved.
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
